import { getDaysDiff } from 'utils/dateFormatUtil';
import { getAsDate } from 'utils/getAsDate';
import { DealType, Line } from 'components/common/types/Deal.types';
import { hasLineEnded, hasLineStarted } from 'components/pages/DealWithLines/common/getActionConditions';

const GUARANTEED_MAX_DURATION_DAYS = 180;

export const getStartOfToday = (): Date => new Date(new Date().setHours(0, 0, 0, 0));

export const getEndOfToday = (): Date => new Date(new Date().setHours(23, 59, 59, 999));

export const getScheduleWarningMessage = (isDealPendingOrRejected: boolean, currentLine: Line): string => {
  if (!isDealPendingOrRejected) return '';

  if (hasLineEnded(currentLine)) {
    return 'The end date of this line has passed. Please revise your end date and save your line.';
  }

  if (hasLineStarted(currentLine)) {
    return 'The start date of this line has passed, which means your line will go live immediately. If you wish to change this, please update your start date.';
  }

  return '';
};

export const isGuaranteedDurationExceeded = (
  dealType: DealType,
  startDate: Date | string | null | undefined,
  endDate: Date | string | null | undefined,
): boolean =>
  dealType === DealType.GUARANTEED &&
  getDaysDiff(startDate || getStartOfToday(), endDate || getEndOfToday()) > GUARANTEED_MAX_DURATION_DAYS;

export const isEndDateWithinGuaranteedLimit = (
  dealType: DealType,
  startDate: Date | string | null | undefined,
  newEndDate: Date,
): boolean =>
  dealType !== DealType.GUARANTEED ||
  getDaysDiff(startDate || getStartOfToday(), newEndDate) <= GUARANTEED_MAX_DURATION_DAYS;

export const shouldNotifyPatternExtension = (
  endDate: Date | string | null | undefined,
  newEndDate: Date,
  isPatternInfoMessage: boolean,
): boolean => Boolean(endDate && newEndDate > getAsDate(endDate, newEndDate) && !isPatternInfoMessage);
